import qs from 'qs';
import _ from 'lodash';

const extractQueryString = (queryString: string) => qs.parse(_.trimStart(queryString, '?'));
export default extractQueryString;
